const ReccSectionShimmer = () => {
  return (
    <>
      <div className="reccShimmerCard">
        <div className="reccShimmerCardImg shine"></div>
        <div className="reccShimmerCardDesc">
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
        </div>
      </div>
      <div className="reccShimmerCard">
        <div className="reccShimmerCardImg shine"></div>
        <div className="reccShimmerCardDesc">
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
        </div>
      </div>
      <div className="reccShimmerCard">
        <div className="reccShimmerCardImg shine"></div>
        <div className="reccShimmerCardDesc">
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
        </div>
      </div>
      <div className="reccShimmerCard">
        <div className="reccShimmerCardImg shine"></div>
        <div className="reccShimmerCardDesc">
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
        </div>
      </div>
      <div className="reccShimmerCard">
        <div className="reccShimmerCardImg shine"></div>
        <div className="reccShimmerCardDesc">
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
        </div>
      </div>
      <div className="reccShimmerCard">
        <div className="reccShimmerCardImg shine"></div>
        <div className="reccShimmerCardDesc">
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
          <div className="reccShimmerLines shine"></div>
        </div>
      </div>
    </>
  );
};
export default ReccSectionShimmer;
